import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ggk3ftnbuv: FaireBrandEntity = {
  token: "b_ggk3ftnbuv",
  type: "brand",
  name: "Hotel Lobby Candle",
  avatarUrl:
    "https://cdn.faire.com/fastly/86415aa112140eef4c905648eb0ac582f26fe175a5659ce2db8573ef10ffc6a4.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/4d91669898253b4cb7ab0fdc1ded116b38ea040f0696af3803b6a34f6f1f90da.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/86415aa112140eef4c905648eb0ac582f26fe175a5659ce2db8573ef10ffc6a4.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4d91669898253b4cb7ab0fdc1ded116b38ea040f0696af3803b6a34f6f1f90da.jpeg",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 696,
  rating: 4.8,
  reviewCount: 17,
  isInsider: true,
  description:
    "Hotel Lobby Candle is a small family business founded in Brooklyn NY by husband and wife duo Lindsay Silberman and Matthew Stevens in October 2020 during the height of the COVID-19 pandemic.\n\nOne of life’s pleasures Lindsay and Matthew missed the most was the magic of a long-awaited vacation (and they were pretty sure they weren’t alone). So they had an idea: If we couldn’t leave our homes, could we bring the five-star hotel experience to us?\n\nThe electric energy of Miami.\nThe mystery and romance of Paris.\nThe balmy, be-happy vibes of the Caribbean.\n\nIn that spirit, HLC fragrances are inspired by the founder's scent memories from their travels around the world. The candles are hand-poured in the USA with 100% soy wax, hand-painted glass vessels, and cotton wicks. \n\nThe packaging is thoughtfully designed and gift-ready and comes complete with a hotel key card with burning instructions as a finishing touch. The full-sized candles are 9.75 oz and have a 65-hour burn time.\n\nHotel Lobby Candle now offers luxury hand wash, reed diffusers, and large 55oz candles in our top-selling scents. A votive set of 5 2.5oz candles is also available and doubles as a small scent sampler.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:34.940Z",
    importedBy: "entity-db-cli",
  },
};
